/**
 * Subagent Coordinator Package
 * Central Nervous System for orchestrating specialized AI agents
 *
 * Self-contained modules:
 * - coordinator/  - Central nervous system
 * - logger/       - Observability (future: @prosdevlab/croak)
 * - planner/      - Planning agent
 * - explorer/     - Code exploration agent
 * - pr/           - GitHub PR agent
 */

export type { StorageAdapter } from './coordinator';
// Main coordinator module
export {
  CompositeStorageAdapter,
  ContextManagerImpl,
  MemoryStorageAdapter,
  SubagentCoordinator,
  TaskQueue,
} from './coordinator';
export { ExplorerAgent } from './explorer';
// Types - Explorer
export type {
  CodeInsights,
  CodeRelationship,
  ExplorationAction,
  ExplorationError,
  ExplorationRequest,
  ExplorationResult,
  InsightsRequest,
  InsightsResult,
  PatternFrequency,
  PatternResult,
  PatternSearchRequest,
  RelationshipRequest,
  RelationshipResult,
  SimilarCodeRequest,
  SimilarCodeResult,
} from './explorer/types';
// Logger module
export { CoordinatorLogger } from './logger';
// Agent modules
export { PlannerAgent } from './planner';
// Types - Context Assembler
export type {
  CodebasePatterns,
  ContextAssemblyOptions,
  ContextMetadata,
  ContextPackage,
  IssueComment,
  IssueContext,
  RelatedHistory,
  RelevantCodeContext,
} from './planner/context-types';
// Types - Planner
export type {
  Plan,
  PlanningError,
  PlanningRequest,
  PlanningResult,
  PlanTask,
  RelevantCode,
} from './planner/types';
// Planner utilities
export {
  addEstimatesToTasks,
  assembleContext,
  breakdownIssue,
  calculateTotalEstimate,
  cleanDescription,
  estimateTaskHours,
  extractAcceptanceCriteria,
  extractEstimate,
  extractTechnicalRequirements,
  formatContextPackage,
  formatEstimate,
  formatJSON,
  formatMarkdown,
  formatPretty,
  groupTasksByPhase,
  inferPriority,
  validateTasks,
} from './planner/utils';
export { PrAgent } from './pr';
// Types - Coordinator
export type {
  Agent,
  AgentContext,
  ContextManager,
  CoordinatorOptions,
  CoordinatorStats,
  Logger,
  LogLevel,
  Message,
  MessageType,
  Task,
  TaskStatus,
} from './types';
